import React, { useState } from "react";
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Col,
  Button,
  Input,
  Label,
  Form,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

// Redux
import { useDispatch } from "react-redux";
import { addNewSeller } from "../../../slices/thunks";

const EcommerceAddSeller = (props) => {
  document.title = "Add Seller - Dashboard";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("1");
  const [companyType, setcompanyType] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    // Personal Details
    first_name: "",
    last_name: "",
    email: "",
    contact_number: "",
    phone_number: "",
    date_of_birth: "",
    city: "",
    country: "",
    zip_code: "",
    description: "",
    password: "",
    // Business Details
    company_name: "",
    company_type: null,
    pan_card_number: "",
    website: "",
    fax: "",
    company_email: "",
    company_number: "",
    company_logo: null,
    // Bank Details
    bank_name: "",
    branch: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
  });

  const companytypes = [
    {
      options: [
        { label: "Select type", value: "Select type" },
        { label: "All", value: "All" },
        { label: "Merchandising", value: "Merchandising" },
        { label: "Manufacturing", value: "Manufacturing" },
        { label: "Partnership", value: "Partnership" },
        { label: "Corporation", value: "Corporation" },
      ],
    },
  ];

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData((prev) => ({
        ...prev,
        company_logo: e.target.files[0],
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.email) {
      toast.error("Email is required");
      return;
    }
    if (!formData.password) {
      toast.error("Password is required");
      return;
    }

    try {
      const submitData = new FormData();

      // Add all form fields to FormData
      Object.keys(formData).forEach((key) => {
        if (key === "company_logo" && formData[key]) {
          submitData.append("company_logo", formData[key]);
        } else if (key === "company_type" && formData[key]) {
          submitData.append("company_type", typeof formData[key] === "object" ? formData[key].value : formData[key]);
        } else if (formData[key] !== null && formData[key] !== "") {
          submitData.append(key, formData[key]);
        }
      });

      await dispatch(addNewSeller({ formData: submitData })).unwrap();

      // Navigate back to sellers list
      navigate("/sellers");
    } catch (error) {
      console.error("Error adding seller:", error);
      // Error toast is handled in the thunk
    }
  };

  return (
    <div className="page-content">
      <ToastContainer position="top-right" autoClose={3000} />
      <Container fluid>
        <BreadCrumb title="Add Seller" pageTitle="Dashboard" />

        <Card>
          <CardHeader>
            <Nav className="nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light">
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: activeTab === "1" })}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab("1");
                  }}
                >
                  Personal Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: activeTab === "2" })}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab("2");
                  }}
                >
                  Business Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: activeTab === "3" })}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab("3");
                  }}
                >
                  Bank Details
                </NavLink>
              </NavItem>
            </Nav>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <div className="tab-content">
                {/* Personal Details Tab */}
                {activeTab === "1" && (
                  <Row>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="firstnameInput" className="form-label">
                          First Name
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="firstnameInput"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleInputChange}
                          placeholder="Enter your firstname"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="lastnameInput" className="form-label">
                          Last Name
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="lastnameInput"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleInputChange}
                          placeholder="Enter your lastname"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="contactnumberInput" className="form-label">
                          Contact Number
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="contactnumberInput"
                          name="contact_number"
                          value={formData.contact_number}
                          onChange={handleInputChange}
                          placeholder="Enter your number"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="phonenumberInput" className="form-label">
                          Phone Number
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="phonenumberInput"
                          name="phone_number"
                          value={formData.phone_number}
                          onChange={handleInputChange}
                          placeholder="Enter your number"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="emailidInput" className="form-label">
                          Email <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="email"
                          className="form-control"
                          id="emailidInput"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="Enter your email"
                          required
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="passwordInput" className="form-label">
                          Password <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="password"
                          className="form-control"
                          id="passwordInput"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          placeholder="Enter password"
                          required
                        />
                      </div>
                    </Col>
                    {/* <Col lg={6}>
                      <div className="mb-3">
                        <Label for="birthdayidInput" className="form-label">
                          Date of Birth
                        </Label>
                        <Flatpickr
                          className="form-control"
                          name="date_of_birth"
                          value={formData.date_of_birth}
                          onChange={(date) => {
                            setFormData((prev) => ({
                              ...prev,
                              date_of_birth: date[0] ? date[0].toISOString().split("T")[0] : "",
                            }));
                          }}
                          options={{
                            dateFormat: "Y-m-d",
                          }}
                          placeholder="Select Date"
                        />
                      </div>
                    </Col> */}
                    <Col lg={4}>
                      <div className="mb-3">
                        <Label for="cityidInput" className="form-label">
                          City
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="cityidInput"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          placeholder="Enter your city"
                        />
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="mb-3">
                        <Label for="countryidInput" className="form-label">
                          Country
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="countryidInput"
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                          placeholder="Enter your country"
                        />
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="mb-3">
                        <Label for="zipcodeidInput" className="form-label">
                          Zip Code
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="zipcodeidInput"
                          name="zip_code"
                          value={formData.zip_code}
                          onChange={handleInputChange}
                          placeholder="Enter your zipcode"
                        />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label for="exampleFormControlTextarea1" className="form-label">
                          Description
                        </Label>
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          name="description"
                          value={formData.description}
                          onChange={handleInputChange}
                          rows="3"
                          placeholder="Enter description"
                        ></textarea>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="hstack gap-2 justify-content-end">
                        <Button
                          type="button"
                          color="light"
                          onClick={() => navigate("/sellers")}
                        >
                          <i className="ri-close-line me-1 align-middle"></i> Cancel
                        </Button>
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => {
                            toggleTab("2");
                          }}
                        >
                          Next <i className="ri-arrow-right-line align-bottom me-1"></i>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                {/* Business Details Tab */}
                {activeTab === "2" && (
                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label for="companynameInput" className="form-label">
                          Company Name
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="companynameInput"
                          name="company_name"
                          value={formData.company_name}
                          onChange={handleInputChange}
                          placeholder="Enter your company name"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="choices-single-default" className="form-label">
                          Company Type
                        </Label>
                        <Select
                          name="company_type"
                          id="choices-single-default"
                          value={companyType}
                          onChange={(selected) => {
                            setcompanyType(selected);
                            setFormData((prev) => ({
                              ...prev,
                              company_type: selected,
                            }));
                          }}
                          options={companytypes[0].options.filter((opt) => opt.value !== "Select type" && opt.value !== "All")}
                        />
                      </div>
                    </Col>
                    {/* <Col lg={6}>
                      <div className="mb-3">
                        <Label for="pancardInput" className="form-label">
                          Pan Card Number
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="pancardInput"
                          name="pan_card_number"
                          value={formData.pan_card_number}
                          onChange={handleInputChange}
                          placeholder="Enter your pan-card number"
                        />
                      </div>
                    </Col> */}
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="websiteInput" className="form-label">
                          Website
                        </Label>
                        <Input
                          type="url"
                          className="form-control"
                          id="websiteInput"
                          name="website"
                          value={formData.website}
                          onChange={handleInputChange}
                          placeholder="Enter your URL"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="faxInput" className="form-label">
                          Fax
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="faxInput"
                          name="fax"
                          value={formData.fax}
                          onChange={handleInputChange}
                          placeholder="Enter your fax"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="companyemailInput" className="form-label">
                          Email
                        </Label>
                        <Input
                          type="email"
                          className="form-control"
                          id="companyemailInput"
                          name="company_email"
                          value={formData.company_email}
                          onChange={handleInputChange}
                          placeholder="Enter your email"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="worknumberInput" className="form-label">
                          Number
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="worknumberInput"
                          name="company_number"
                          value={formData.company_number}
                          onChange={handleInputChange}
                          placeholder="Enter your number"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="companylogoInput" className="form-label">
                          Company Logo
                        </Label>
                        <Input
                          type="file"
                          className="form-control"
                          id="companylogoInput"
                          name="company_logo"
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="hstack gap-2 justify-content-end">
                        <Button
                          type="button"
                          color="light"
                          onClick={() => navigate("/sellers")}
                        >
                          <i className="ri-close-line me-1 align-middle"></i> Cancel
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => {
                            toggleTab("1");
                          }}
                        >
                          <i className="ri-arrow-left-line align-bottom me-1"></i> Previous
                        </Button>
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => {
                            toggleTab("3");
                          }}
                        >
                          Next <i className="ri-arrow-right-line align-bottom me-1"></i>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                {/* Bank Details Tab */}
                {activeTab === "3" && (
                  <Row>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="banknameInput" className="form-label">
                          Bank Name
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="banknameInput"
                          name="bank_name"
                          value={formData.bank_name}
                          onChange={handleInputChange}
                          placeholder="Enter your bank name"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="branchInput" className="form-label">
                          Branch
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="branchInput"
                          name="branch"
                          value={formData.branch}
                          onChange={handleInputChange}
                          placeholder="Branch"
                        />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label for="accountnameInput" className="form-label">
                          Account Holder Name
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="accountnameInput"
                          name="account_holder_name"
                          value={formData.account_holder_name}
                          onChange={handleInputChange}
                          placeholder="Enter account holder name"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="accountnumberInput" className="form-label">
                          Account Number
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="accountnumberInput"
                          name="account_number"
                          value={formData.account_number}
                          onChange={handleInputChange}
                          placeholder="Enter account number"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label for="ifscInput" className="form-label">
                          IFSC
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="ifscInput"
                          name="ifsc_code"
                          value={formData.ifsc_code}
                          onChange={handleInputChange}
                          placeholder="IFSC"
                        />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="hstack gap-2 justify-content-end">
                        <Button
                          type="button"
                          color="light"
                          onClick={() => navigate("/sellers")}
                        >
                          <i className="ri-close-line me-1 align-middle"></i> Cancel
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => {
                            toggleTab("2");
                          }}
                        >
                          <i className="ri-arrow-left-line align-bottom me-1"></i> Previous
                        </Button>
                        <Button type="submit" color="primary">
                          <i className="ri-save-3-line align-bottom me-1"></i> Save All
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EcommerceAddSeller;
